module.exports = __webpack_public_path__ + "img/qrcode2.cf5ebc8e.png";